import axios from 'axios';

const apiAgentGroups = axios.create({
  baseURL: process.env.REACT_APP_SKYCOMMS_API + '/agent-groups',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiAgentGroups;